import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonRow,
  IonSegment,
  IonSegmentButton,
  IonText,
  IonToolbar,
} from "@ionic/react";
import { closeCircleOutline } from "ionicons/icons";
import React, { useEffect, useState, useContext } from "react";
import AppPrefContext from "../../../components/contexts/AppPrefContext";
import { each } from "underscore";
import { v4 as uuidv4 } from "uuid";
import { CapacitorPreferencesConstants } from "../../../components/Constants";
import config from "../../../components/helpers/socket/config";
import { pubsubEvents } from "../../../components/helpers/socket/pubsubEvent";
import { startsWith } from "../../../utils/commonUtils";
import {
  removeCapacitorPreference,
  setCapacitorPreference,
} from "../../../utils/core-utils/capPreferencesUtils";
import { send } from "../../../utils/sockets/asyncSocket";
import { CMEDPermissions } from "../MarketData/MarketDataContent";
import OrderEntryModal from "../MarketData/OrderEntryModal";
import optionsGridConfig from "./optionsGridConfig";
import { OrdersType } from "../../../Constants";

/**
 * @author
 * E45597 Aryamitra Chaudhuri
 */

type OptionsGridViewModalProps = {
  isOptionsGridViewModalOpen: boolean;
  setIsOptionsGridViewModalOpen: Function;
  selectedOption: any;
  strike: string;
  optionGridData: any;
  userCMEDEntitlements: CMEDPermissions | undefined;
  orderEntryData: any;
  orderEntryData_Live: any;
  openOrderEntryModal: boolean;
  setOpenOrderEntryModal: Function;
  orderEntryType: any;
  setOrderEntryType: Function;
  type: any;
  setType: Function;
  notATM?: boolean;
};

const OptionsGridViewModal: React.FC<OptionsGridViewModalProps> = ({
  isOptionsGridViewModalOpen,
  setIsOptionsGridViewModalOpen,
  selectedOption,
  strike,
  userCMEDEntitlements,
  orderEntryData,
  orderEntryData_Live,
  openOrderEntryModal,
  setOpenOrderEntryModal,
  orderEntryType,
  setOrderEntryType,
  type,
  setType,
  notATM,
}) => {
  const appPref = useContext(AppPrefContext);

  const [callDepth, setcallDepth] = useState<any>();

  const [putDepth, setputDepth] = useState<any>();

  const [priceType, setpriceType] = useState(undefined);

  const termStructureCode = selectedOption?.TermStructureCode;
  const strikeStr = strike?.toString();

  function setOptionGridDepth(res: any) {
    // const payload:any = res.payload.data

    const callDepthArr: any[] = [];
    const putDepthArr: any[] = [];

    if (res.payload.isSnapshot) {
      each(res.payload.data, (row) => {
        if (row.o === 1) {
          callDepthArr.push(row);
        } else {
          putDepthArr.push(row);
        }
      });
      setcallDepth(callDepthArr);
      setputDepth(putDepthArr);
    } else {
      const callDepthNew: any[] = [];
      const putDepthNew: any[] = [];

      each(res.payload.data, (row) => {
        if (row.o === 1) {
          callDepthNew.push(row);
        } else {
          putDepthNew.push(row);
        }
      });

      setcallDepth((prevObjects: any) => {
        const updatedObjects = [...prevObjects]; // Create a copy of the existing objects

        updatedObjects.map((p: any, index1: any) => {
          //existing data
          callDepthNew.map((q: any, index2: any) => {
            if (p.id === q.id) {
              updatedObjects[index1] = q;
            }
          });
        });
        return updatedObjects;
      });
      setputDepth((prevObjects: any) => {
        const updatedObjects = [...prevObjects]; // Create a copy of the existing objects

        updatedObjects.map((p: any, index1: any) => {
          //existing data
          putDepthNew.map((q: any, index2: any) => {
            if (p.id === q.id) {
              updatedObjects[index1] = q;
            }
          });
        });
        return updatedObjects;
      });
    }
  }

  let subRequestForOptionsGridGroupItemDepth = {
    action: optionsGridConfig.socket.actions.CMED_SUBSCRIBE_STRIKE_LADDER_DEPTH,
    type: OrdersType.OPTIONS_GRID_GROUP_ITEM_DEPTH,
    requestID: uuidv4(),
    payload: {
      termStructureCode: termStructureCode,
      strike: strikeStr,
      levels: "5",
    },
  };

  let unSubRequestForOptionsGridGroupItemDepth = {
    action:
      optionsGridConfig.socket.actions.CMED_UNSUBSCRIBE_STRIKE_LADDER_DEPTH,
    type: OrdersType.OPTIONS_GRID_GROUP_ITEM_DEPTH,
    requestID: uuidv4(),
    payload: {
      termStructureCode: termStructureCode,
    },
  };

  useEffect(() => {
    if (isOptionsGridViewModalOpen) {
      PubSub.subscribe(
        optionsGridConfig.socketKeys.CMED_SUPPLEMENTAL_DEPTH,
        async (msg, data) => {
          setOptionGridDepth(data);
        },
      );
    }
  }, [isOptionsGridViewModalOpen]);

  useEffect(() => {
    if (isOptionsGridViewModalOpen && appPref?.isAppActive) {
      if (termStructureCode && strikeStr) {
        send(
          config.socket.channels.TRADING,
          subRequestForOptionsGridGroupItemDepth,
        );
      }
    }
  }, [strikeStr, isOptionsGridViewModalOpen, appPref?.isAppActive]);

  useEffect(() => {
    if (isOptionsGridViewModalOpen) {
      if (termStructureCode) {
        setCapacitorPreference(
          CapacitorPreferencesConstants.OPTIONS_GRID_TSCODE,
          termStructureCode,
        );
      }
      if (strikeStr) {
        setCapacitorPreference(
          CapacitorPreferencesConstants.OPTIONS_GRID_STRIKE,
          strikeStr,
        );
      }
    }
  }, [strikeStr, isOptionsGridViewModalOpen]);

  const RenderMobileHeader = () => {
    return (
      <IonItem
        className="ion-no-padding one_orderbook_item"
        lines="none"
        color="primary"
        style={{ height: "30px", display: "flex" }}
      >
        <IonLabel className="ion-no-margin ion-no-padding">
          <div className="cme_list_item_parent">
            <IonGrid fixed={true} className="ion-no-margin ion-no-padding">
              <IonRow className="cme_list_item_details ion-no-margin ion-no-padding">
                <IonCol
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    padding: 5,
                  }}
                >
                  <p>Bid Qty</p>
                </IonCol>
                <IonCol
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    padding: 5,
                  }}
                >
                  <p>Bid Price</p>
                </IonCol>
                <IonCol
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    padding: 5,
                  }}
                >
                  <p>Offer Price</p>
                </IonCol>
                <IonCol
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    padding: 5,
                  }}
                >
                  <p>Offer Qty</p>
                </IonCol>
              </IonRow>
            </IonGrid>
          </div>
        </IonLabel>
      </IonItem>
    );
  };

  let index = 2;

  return (
    <>
      <IonModal isOpen={isOptionsGridViewModalOpen}>
        <IonHeader className="ion-no-border">
          <IonToolbar>
            <IonText
              className="ion-text-center"
              style={{
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingLeft: "30px",
                paddingTop: "5px",
              }}
            >
              {selectedOption?.TermStructureDescription +
                " " +
                orderEntryData?.data[0]?.s?.f}
            </IonText>
            <IonButtons slot="end">
              <IonButton
                style={{ margin: "0" }}
                onClick={() => {
                  setIsOptionsGridViewModalOpen(false);
                  termStructureCode &&
                    send(
                      config.socket.channels.TRADING,
                      unSubRequestForOptionsGridGroupItemDepth,
                    );
                  termStructureCode &&
                    removeCapacitorPreference(
                      CapacitorPreferencesConstants.OPTIONS_GRID_TSCODE,
                    );
                  strikeStr &&
                    removeCapacitorPreference(
                      CapacitorPreferencesConstants.OPTIONS_GRID_STRIKE,
                    );
                }}
              >
                <IonIcon
                  style={{ fontSize: "25px" }}
                  icon={closeCircleOutline}
                ></IonIcon>
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonSegment
          value={type}
          onIonChange={(e: any) => setType(e.target.value)}
        >
          <IonSegmentButton value="call">
            <IonLabel>CALL</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="put">
            <IonLabel>PUT</IonLabel>
          </IonSegmentButton>
        </IonSegment>
        {type === "call" && callDepth !== undefined && (
          <IonList inset={true}>
            <IonItem color="light">
              <IonLabel>Volume</IonLabel>
              <IonLabel slot="end">
                {orderEntryData !== undefined &&
                orderEntryData !== null &&
                orderEntryData["data"][0] !== undefined &&
                orderEntryData["data"][0].tv !== undefined &&
                orderEntryData["data"][0].tv !== null
                  ? orderEntryData["data"][0]?.tv?.f
                  : "-"}
              </IonLabel>
            </IonItem>
            <IonItem color="light">
              <IonLabel>Last</IonLabel>
              {/* optionGridData[1].data[0].tv.f */}
              <IonLabel slot="end">
                {orderEntryData !== undefined &&
                orderEntryData !== null &&
                orderEntryData["data"][0] !== undefined &&
                orderEntryData["data"][0].l !== undefined &&
                orderEntryData["data"][0].l !== null
                  ? orderEntryData["data"][0]?.l?.f
                  : "-"}
              </IonLabel>
            </IonItem>
            <IonItem color="light">
              <IonLabel>Change</IonLabel>
              <IonLabel slot="end">
                {orderEntryData !== undefined &&
                orderEntryData !== null &&
                orderEntryData["data"][0] !== undefined &&
                orderEntryData["data"][0].n !== undefined &&
                orderEntryData["data"][0]?.n !== null ? (
                  <IonText
                    color={
                      startsWith(orderEntryData["data"][0]?.n?.f, "-")
                        ? "danger"
                        : "primary"
                    }
                  >
                    <p className="number-font-family">
                      {orderEntryData["data"][0]?.n?.f}
                    </p>
                  </IonText>
                ) : (
                  "-"
                )}
              </IonLabel>
              {/* <IonLabel slot="end">{optionGridData !== undefined && optionGridData !== null ? optionGridData[1].data[0].n.f : "0"}</IonLabel> */}
            </IonItem>
          </IonList>
        )}
        {type === "put" && putDepth !== undefined && (
          <IonList inset={true}>
            <IonItem color="light">
              <IonLabel>Volume</IonLabel>
              <IonLabel slot="end">
                {orderEntryData !== undefined &&
                orderEntryData !== null &&
                orderEntryData["data"][1] !== undefined &&
                orderEntryData["data"][1].tv !== undefined &&
                orderEntryData["data"][1].tv !== null
                  ? orderEntryData["data"][1]?.tv?.f
                  : "-"}
              </IonLabel>
            </IonItem>
            <IonItem color="light">
              <IonLabel>Last</IonLabel>
              {/* optionGridData[1].data[0].tv.f */}
              <IonLabel slot="end">
                {orderEntryData !== undefined &&
                orderEntryData !== null &&
                orderEntryData["data"][1] !== undefined &&
                orderEntryData["data"][1].l !== undefined &&
                orderEntryData["data"][1].l !== null
                  ? orderEntryData["data"][1]?.l?.f
                  : "-"}
              </IonLabel>
            </IonItem>
            <IonItem color="light">
              <IonLabel>Change</IonLabel>
              <IonLabel slot="end">
                {orderEntryData !== undefined &&
                orderEntryData !== null &&
                orderEntryData["data"][1] !== undefined &&
                orderEntryData["data"][1].n !== undefined &&
                orderEntryData["data"][1]?.n !== null ? (
                  <IonText
                    color={
                      startsWith(orderEntryData["data"][1]?.n?.f, "-")
                        ? "danger"
                        : "primary"
                    }
                  >
                    <p className="number-font-family">
                      {orderEntryData["data"][1]?.n?.f}
                    </p>
                  </IonText>
                ) : (
                  "-"
                )}
              </IonLabel>
              {/* <IonLabel slot="end">{optionGridData !== undefined && optionGridData !== null ? optionGridData[1].data[0].n.f : "0"}</IonLabel> */}
            </IonItem>
          </IonList>
        )}
        <RenderMobileHeader />
        <IonContent>
          {type === "call" &&
            callDepth !== undefined &&
            callDepth.map((e: any) => {
              return (
                <React.Fragment>
                  <IonItem
                    button
                    detail={false}
                    className={`ion-no-padding one_orderbook_item ${
                      index % 2 === 0 ? "even_item_bg" : ""
                    }`}
                    lines="none"
                    onClick={() => setIsOptionsGridViewModalOpen(true)}
                  >
                    <IonLabel className="ion-no-margin ion-no-padding">
                      <div className="number-font-family cme_list_item_parent">
                        <IonGrid
                          fixed={true}
                          className="ion-no-margin ion-no-padding"
                        >
                          <IonRow className="cme_list_item_details ion-no-margin ion-no-padding">
                            <IonCol
                              style={{
                                backgroundColor: "#2781ff15",
                                height: "44px",
                                display: "flex",
                                alignItems: "center",
                                padding: 5,
                              }}
                            >
                              <p>{e?.bq?.f}</p>
                            </IonCol>
                            <IonCol
                              style={{
                                backgroundColor: "#2781ff20",
                                height: "44px",
                                display: "flex",
                                alignItems: "center",
                                padding: 5,
                              }}
                            >
                              <p>{e?.b?.f}</p>
                            </IonCol>
                            <IonCol
                              style={{
                                backgroundColor: "#e83d3d16",
                                height: "44px",
                                display: "flex",
                                alignItems: "center",
                                padding: 5,
                              }}
                            >
                              <p>{e?.op?.f}</p>
                            </IonCol>
                            <IonCol
                              style={{
                                backgroundColor: "#e83d3d09",
                                height: "44px",
                                display: "flex",
                                alignItems: "center",
                                padding: 5,
                              }}
                            >
                              <p>{e?.oq?.f}</p>
                            </IonCol>
                          </IonRow>
                        </IonGrid>
                      </div>
                    </IonLabel>
                  </IonItem>
                </React.Fragment>
              );
            })}
          {type === "put" &&
            putDepth !== undefined &&
            putDepth.map((e: any) => {
              return (
                <React.Fragment>
                  <IonItem
                    button
                    detail={false}
                    className={`ion-no-padding one_orderbook_item ${
                      index % 2 === 0 ? "even_item_bg" : ""
                    }`}
                    lines="none"
                    onClick={() => setIsOptionsGridViewModalOpen(true)}
                  >
                    <IonLabel className="ion-no-margin ion-no-padding">
                      <div className="cme_list_item_parent number-font-family">
                        <IonGrid
                          fixed={true}
                          className="ion-no-margin ion-no-padding"
                        >
                          <IonRow className="cme_list_item_details ion-no-margin ion-no-padding">
                            <IonCol
                              style={{
                                backgroundColor: "#2781ff15",
                                height: "44px",
                                display: "flex",
                                alignItems: "center",
                                padding: 5,
                              }}
                            >
                              <p>{e?.bq?.f}</p>
                            </IonCol>
                            <IonCol
                              style={{
                                backgroundColor: "#2781ff20",
                                height: "44px",
                                display: "flex",
                                alignItems: "center",
                                padding: 5,
                              }}
                            >
                              <p>{e?.b?.f}</p>
                            </IonCol>
                            <IonCol
                              style={{
                                backgroundColor: "#e83d3d16",
                                height: "44px",
                                display: "flex",
                                alignItems: "center",
                                padding: 5,
                              }}
                            >
                              <p>{e?.op?.f}</p>
                            </IonCol>
                            <IonCol
                              style={{
                                backgroundColor: "#e83d3d09",
                                height: "44px",
                                display: "flex",
                                alignItems: "center",
                                padding: 5,
                              }}
                            >
                              <p>{e?.oq?.f}</p>
                            </IonCol>
                          </IonRow>
                        </IonGrid>
                      </div>
                    </IonLabel>
                  </IonItem>
                </React.Fragment>
              );
            })}
        </IonContent>
        <IonFooter>
          {type === "call" && callDepth !== undefined && (
            <IonToolbar>
              <IonGrid>
                <IonRow>
                  <IonCol>
                    <IonButton
                      color="primary"
                      expand="block"
                      // className='new-bid-button'
                      onClick={() => {
                        setOrderEntryType("bid");
                        setOpenOrderEntryModal(true);
                      }}
                      disabled={
                        orderEntryData === undefined ||
                        orderEntryData === null ||
                        orderEntryData["data"][0] === undefined ||
                        orderEntryData["data"][0] === null
                      }
                      fill="solid"
                    >
                      NEW BID
                    </IonButton>
                  </IonCol>
                  <IonCol>
                    <IonButton
                      color="danger"
                      expand="block"
                      // className='new-offer-button'
                      onClick={() => {
                        setOrderEntryType("offer");
                        setOpenOrderEntryModal(true);
                      }}
                      disabled={
                        orderEntryData === undefined ||
                        orderEntryData === null ||
                        orderEntryData["data"][0] === undefined ||
                        orderEntryData["data"][0] === null
                      }
                      fill="solid"
                    >
                      NEW OFFER
                    </IonButton>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonToolbar>
          )}
          {type === "put" && putDepth !== undefined && (
            <IonToolbar>
              <IonGrid>
                <IonRow>
                  <IonCol>
                    <IonButton
                      color="primary"
                      expand="block"
                      // className='new-bid-button'
                      onClick={() => {
                        setOrderEntryType("bid");
                        setOpenOrderEntryModal(true);
                      }}
                      disabled={
                        orderEntryData === undefined ||
                        orderEntryData === null ||
                        orderEntryData["data"][1] === undefined ||
                        orderEntryData["data"][1] === null
                      }
                      fill="solid"
                    >
                      NEW BID
                    </IonButton>
                  </IonCol>
                  <IonCol>
                    <IonButton
                      color="danger"
                      expand="block"
                      // className='new-offer-button'
                      onClick={() => {
                        setOrderEntryType("offer");
                        setOpenOrderEntryModal(true);
                      }}
                      disabled={
                        orderEntryData === undefined ||
                        orderEntryData === null ||
                        orderEntryData["data"][1] === undefined ||
                        orderEntryData["data"][1] === null
                      }
                      fill="solid"
                    >
                      NEW OFFER
                    </IonButton>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonToolbar>
          )}
        </IonFooter>
      </IonModal>
      <OrderEntryModal
        type="options"
        orderEntryType={orderEntryType}
        openOrderEntryModal={openOrderEntryModal}
        setOpenOrderEntryModal={setOpenOrderEntryModal}
        selectedOption={selectedOption}
        orderEntryData={
          type === "call"
            ? orderEntryData["data"][0]
            : orderEntryData["data"][1]
        }
        userCMEDEntitlements={userCMEDEntitlements}
        componentusedIn="optionsGrid"
        priceType={priceType}
        setpriceType={setpriceType}
        orderEntryData_Live={
          type === "call"
            ? orderEntryData_Live["data"][0]
            : orderEntryData_Live["data"][1]
        }
      />
    </>
  );
};

export default OptionsGridViewModal;
